import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/content";

export default function StickyCTA() {
  return (
    <a
      data-testid="sticky-call-cta"
      href={`tel:${COMPANY.phoneRaw}`}
      className="md:hidden fixed bottom-4 left-4 right-4 z-50 inline-flex items-center justify-center gap-3 px-6 py-4 bg-gradient-to-r from-blue-600 to-violet-600 text-white font-bold uppercase tracking-wider text-sm rounded-sm glow-blue"
    >
      <Phone className="w-4 h-4" />
      Hívd most · {COMPANY.phone}
    </a>
  );
}
